import { render, staticRenderFns } from "./DateStyleEditor.vue?vue&type=template&id=b6273164&scoped=true&"
import script from "./DateStyleEditor.vue?vue&type=script&lang=ts&"
export * from "./DateStyleEditor.vue?vue&type=script&lang=ts&"
import style0 from "./DateStyleEditor.vue?vue&type=style&index=0&id=b6273164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6273164",
  null
  
)

export default component.exports